import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  padding-right: 5.1vw;
  padding-left: 5.1vw;
  margin-right: auto;
  margin-left: auto;
`;

export default Container;
